module.exports = __webpack_public_path__ + "img/btn_sound_on@2x.1e420b1b.png";